import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';

import {location} from '~/actions/AccountActions';
import * as AnalyticsActions from '~/actions/AnalyticsActions';
import {
  resetAfterSavePath,
  setAfterSavePath,
  setOrderOptionsPath,
  getOrderOptionsPath,
  setOrderType
} from '~/slices/pathSlice';
import {prompt} from '~/actions/NotificationActions';
import {validateActiveProducts} from '~/actions/ProductActions';
import {selectIcons} from '~/actions/SelectionActions';
import {handleDesignCombination} from '~/actions/DesignActions';

import {isInternalUser} from '~/selectors/AccountSelectors';
import {
  getIconsArray,
  hasMultipleSelectedIcons,
  hasNamesAndNumbers,
  hasSleeveDesign,
  isBlank as isCanvasBlank
} from '~/selectors/CanvasSelectors';
import {
  selectDesignCidsInCart,
  selectIsCurrentDesignInCart
} from '~/slices/cartSlice';
import {
  getSimplePricingTestValue,
  isLabExitWarningEligible,
  isMultiItemEligible,
  simplePricingTestEnabled,
  wtoTestValue,
  isCiHeaderEnabled
} from '~/selectors/ConfigSelectors';
import {isDirty as isDesignDirty} from '~/selectors/DesignSelectors';
import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {
  anchorStyleHasSleeveView,
  getErrorFreeSelectedProduct as currentProduct,
  getAnchorStyleId
} from '~/selectors/ProductSelectors';
import {isActive as isWelcomeActive} from '~/selectors/WelcomeSelectors';
import {selectCartItemsCount} from '~/api/designs/cartApi';
import {
  allowsNamesAndNumbers,
  isUnquoteable
} from '~/selectors/ProductSelectors';

export function select() {
  return createStructuredSelector({
    allowsNamesAndNumbers,
    anchorStyleHasSleeveView,
    anchorStyleId: getAnchorStyleId,
    blankDesign: isCanvasBlank,
    cartItemCount: selectCartItemsCount,
    compositeIds: selectDesignCidsInCart,
    currentProduct,
    designDirty: isDesignDirty,
    hasMultipleSelectedIcons,
    hasNamesAndNumbers,
    hasSleeveDesign,
    icons: getIconsArray,
    isCurrentDesignInCart: selectIsCurrentDesignInCart,
    isFundraisingMode,
    isInternalUser,
    isLabExitWarningEligible,
    isMultiItemEligible,
    isCiHeaderEnabled,
    isUnquoteable,
    simplePricingTestEnabled,
    simplePricingTestValue: getSimplePricingTestValue,
    orderOptionsPath: getOrderOptionsPath,
    welcomeActive: isWelcomeActive,
    wtoTestGroup: wtoTestValue
  });
}

export function actions(dispatch) {
  return {
    determineLocation: bindActionCreators(location, dispatch),
    meta: bindActionCreators(AnalyticsActions, dispatch),
    prompt: bindActionCreators(prompt, dispatch),
    resetAfterSavePath: bindActionCreators(resetAfterSavePath, dispatch),
    selectIcons: bindActionCreators(selectIcons, dispatch),
    setAfterSavePath: bindActionCreators(setAfterSavePath, dispatch),
    setCombineDesigns: bindActionCreators(handleDesignCombination, dispatch),
    setOrderOptionsPath: bindActionCreators(setOrderOptionsPath, dispatch),
    setOrderType: bindActionCreators(setOrderType, dispatch),
    validateActiveProducts: bindActionCreators(validateActiveProducts, dispatch)
  };
}
